export var RECOMMENDER_DESKTOP_LIMIT = 30;
export var RECOMMENDER_MOBILE_LIMIT = 20;
export var RECOMMENDER_EVENT_LIMIT = 20;
export var BRAND_SLUGS_WITH_RESTRICTED_RECOMMENDERS = ["apple"]; // 2440: Dyson

export var SELLER_IDS_WITH_RESTRICTED_RECOMMENDERS = ["2440"];